<template>
  <div id="member-validation form" class="edit-form">
    <div class="row">
      <div class="materialized col-xs-12">
        <div class="form-group materialized">
          <input type="text" class="form-control" placeholder="Member Number or Check-In Code"
                 id="memberIdentifier"
                 name="memberIdentifier"
                 v-model="memberValidationData.memberIdentifier"
                 :data-vv-scope="validationScope"
                 v-validate="'required|max:15|min:1'"
                 maxlength="15"
                 >
          <label for="memberIdentifier">Member Number or Check-In Code</label>
          <span class="input-group-btn btn btn-view pull-right">
            <button type="button" class="btn btn-link"
                    v-on:click="$emit('openModal')">
              <i class="fa fa-question-circle-o" aria-hidden="true" title="Where is my Member Number or Check-In Code?"></i>
            </button>
          </span>

          <span v-show="errors.has(validationScope + '.memberIdentifier')" class="help form-errors">
            {{ errors.first(validationScope + '.memberIdentifier') }}
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="materialized col-xs-12">
        <div class="form-group materialized">
          <the-mask type="text" class="form-control"
                    mask="##/##/####"
                    id="birthDate"
                    name="birthDate"
                    :data-vv-scope="validationScope"
                    v-model="memberValidationData.birthDate"
                    v-validate="'required|max:10|birthDateFormatValidator'"
                    v-bind:birthDate="memberValidationData.birthDate"
                    :aria-invalid="errors.has(validationScope + '.birthDate')"
                    placeholder="Birth Date (MM/DD/YYYY)">
          </the-mask>
          <label for="birthDate">Birth Date (MM/DD/YYYY)</label>
          <span v-show="errors.has(validationScope + '.birthDate')" class="help form-errors">
            {{ errors.first(validationScope + '.birthDate') }}
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="form-group materialized col-xs-12 col-md5 buttons">
        <div class="col-xs-6">
          <button class="btn btn-default" v-on:click="goToLogin">Cancel</button>
        </div>
        <div class="col-xs-6">
          <button class="btn btn-primary"
            :disabled="isFormSubmitted || errors.any(validationScope) || !isFormValidated"
            v-on:click="validateMember()">
            <i class="fa fa-cog fa-spin fa-fw margin-bottom security-saving-icon"
                v-show="isFormSubmitted"></i>Continue</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import { birthDateFormatValidator } from '../services/custom-validators'

  export default {
    name: 'member-validaton-form',
    inject: ['$validator'],
    props: {
      reEnableSubmitButton: false,
      memberLoginUrl: '',
      validationScope: {
        type: String,
        default: 'memberData'
      }
    },
    data () {
      return {
        isFormSubmitted: false,
        memberValidationData: {
          memberIdentifier: '',
          birthDate: ''
        }
      }
    },
    created () {
      this.$validator.extend('birthDateFormatValidator', birthDateFormatValidator)
    },
    methods: {
      validateMember () {
        this.isFormSubmitted = true
        this.memberValidationData.birthDate = this.memberBirthdate
        this.$emit('submitData', this.memberValidationData)
      },

      openModal () {
        this.$emit('openModal')
      },

      goToLogin () {
        window.open(this.memberLoginUrl, '_self')
      }

    },
    computed: {
      memberBirthdate () {
        let date = this.memberValidationData.birthDate
        if (date.length === 8) {
          return date.substring(0, 2) + '/' + date.substring(2, 4) + '/' + date.substring(4, 8)
        } else {
          return date
        }
      },

      isFormValidated () {
        if (this.fields.$memberData) {
          return Object.keys(this.fields.$memberData).every(key => this.fields.$memberData[key].valid)
        } else {
          return false
        }
      }

    },
    watch: {
      reEnableSubmitButton: function (value) {
        if (value) {
          this.isFormSubmitted = !value
        }
      }
    }
  }
</script>

<style lang="scss" scoped="'true">
  .buttons {

    margin: 70px 0px 0px 0px;

    button {
      width: 100%;
    }
  }

  .fa {
    font-size: 18px;
  }

</style>



// WEBPACK FOOTER //
// src/components/MemberValidationForm.vue